import React, { memo } from 'react';
import { View, Image } from 'react-native';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { rem } from './values';
import EmojiText from './EmojiText';
const EachLogo = ({ logo, index }) => {
    const styles = useStyles(styleSet);
    return (<View style={[
            styles.eachLogoContainer,
            { left: -index * rem(16) },
            typeof logo !== 'string' && styles.noBorder,
        ]}>
      {typeof logo === 'string' ? (<EmojiText fontSize={rem(24)}>{logo}</EmojiText>) : (<Image source={logo} style={styles.logo} resizeMode="cover"/>)}
    </View>);
};
const LogoStack = ({ logos }) => {
    const styles = useStyles(styleSet);
    return (<View style={[
            styles.container,
            {
                width: ACTUAL_LOGO_SIZE +
                    (logos.length - 1) * (ACTUAL_LOGO_SIZE - rem(16)),
            },
        ]}>
      {logos.map((logo, index) => (<EachLogo logo={logo} key={index} index={index}/>))}
    </View>);
};
export default memo(LogoStack);
const ACTUAL_LOGO_SIZE = rem(44);
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
    },
    eachLogoContainer: {
        overflow: 'hidden',
        borderWidth: rem(1),
        alignItems: 'center',
        width: ACTUAL_LOGO_SIZE,
        height: ACTUAL_LOGO_SIZE,
        justifyContent: 'center',
        borderRadius: ACTUAL_LOGO_SIZE,
        borderColor: colors.borders.logoStroke,
        backgroundColor: colors.background.dark,
    },
    logo: {
        width: '100%',
        height: '100%',
    },
    noBorder: {
        borderWidth: 0,
    },
}));
